'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchOpporunitiesSummary = exports.fetchOpenLeadsValue = exports.fetchOpenLeads = exports.fetchPriceSum = undefined;

var _callApi = require('./callApi');

var _callApi2 = _interopRequireDefault(_callApi);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fetchPriceSum = exports.fetchPriceSum = function fetchPriceSum() {
  return (0, _callApi2.default)('GET', '/reports/price-sum', null, 'application/json');
};
var fetchOpenLeads = exports.fetchOpenLeads = function fetchOpenLeads() {
  return (0, _callApi2.default)('GET', '/reports/open-leads', null, 'application/json');
};
var fetchOpenLeadsValue = exports.fetchOpenLeadsValue = function fetchOpenLeadsValue() {
  return (0, _callApi2.default)('GET', '/reports/open-leads-value', null, 'application/json');
};
var fetchOpporunitiesSummary = exports.fetchOpporunitiesSummary = function fetchOpporunitiesSummary() {
  return (0, _callApi2.default)('GET', '/reports/opportunities-summary', null, 'application/json');
};


//////////////////
// WEBPACK FOOTER
// ./~/@hailtrace/client-api/dist/legacy/reports.js
// module id = 741
// module chunks = 0